import React, { useMemo, memo } from "react";

const TotalesEncabezadoListaEmpaque = ({ pedido, previewData }) => {
  const sumaTotalCajas = useMemo(
    () =>
      previewData.reduce(
        (acc, row) => acc + (parseFloat(row.CantCajas) || 0),
        0,
      ),
    [previewData],
  );
  const sumaCMBTotal = useMemo(
    () =>
      previewData.reduce(
        (acc, row) => acc + (parseFloat(row.CBMTotal) || 0),
        0,
      ),
    [previewData],
  );
  const sumaPesoBruto = useMemo(
    () =>
      previewData.reduce(
        (acc, row) => acc + (parseFloat(row.PesoBruto) || 0),
        0,
      ),
    [previewData],
  );
  const tiposMciaTotales = useMemo(
    () =>
      previewData.reduce((acc, row) => {
        const tipo = row.TipoMcia || "Sin Tipo";
        acc[tipo] = (acc[tipo] || 0) + 1;
        return acc;
      }, {}),
    [previewData],
  );

  const tiposMciaArray = useMemo(
    () =>
      Object.entries(tiposMciaTotales).map(
        ([tipo, cantidad]) => `${tipo}: ${cantidad}`,
      ),
    [tiposMciaTotales],
  );

  return (
    <div className="pedido-details-horizontal">
      <div className="pedido-info">
        <strong>ID Pedido:</strong> {pedido?.idpedido || "No disponible"}
      </div>
      <div className="pedido-info">
        <strong>Cliente:</strong> {pedido?.sNombreCliente || "No disponible"}
      </div>
      <div className="pedido-info">
        <strong>Marca:</strong> {pedido?.sMarca || "No disponible"}
      </div>
      <div className="pedido-info">
        <strong>Fecha Pedido:</strong>{" "}
        {pedido?.fecha_pedido
          ? new Date(pedido.fecha_pedido).toLocaleDateString()
          : "No disponible"}
      </div>
      <div className="pedido-info">
        <strong>Descripción Mercancía:</strong>{" "}
        {pedido?.descripcion_mercancia || "No disponible"}
      </div>
      <div className="pedido-info">
        <strong>Ítems:</strong> {previewData.length}
      </div>
      <div className="pedido-info">
        <strong>Cajas:</strong> {sumaTotalCajas.toFixed(0)}
      </div>
      <div className="pedido-info">
        <strong>CBM Total:</strong> {sumaCMBTotal.toFixed(2)}
      </div>
      <div className="pedido-info">
        <strong>Peso Bruto:</strong> {sumaPesoBruto.toFixed(2)}
      </div>
      <div className="pedido-info">
        <strong>Tipos de Mercancía:</strong>
        <ul className="tipos-mcia-list">
          {tiposMciaArray.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default memo(TotalesEncabezadoListaEmpaque);
